import { render, staticRenderFns } from "./mycontacts.vue?vue&type=template&id=15ab3883&"
import script from "./mycontacts.vue?vue&type=script&lang=js&"
export * from "./mycontacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports